import React from "react";
import { XAxis, YAxis } from "../hooks/useBarChartFormState";
import { Input, Select, TextArea } from "@aidkitorg/component-library";
import { useAggregationOptions } from "../hooks/useAggregationOptions";
import { useLocalizedStrings } from "../../../Localization";
import { useFieldOptions } from "../../hooks/useFieldOptions";

export type BarChartFormFieldsProps = {
  title: string,
  setTitle: (val: string) => void,

  description: string,
  setDescription: (val: string) => void,

  xAxis: XAxis,
  setXAxis: (val: XAxis) => void,

  yAxis: YAxis,
  setYAxis: (val: YAxis) => void,
}

export const BarChartFormFields: React.FC<BarChartFormFieldsProps> = ({
  title, setTitle,
  description, setDescription,
  xAxis, setXAxis,
  yAxis, setYAxis,
}) => {
  const L = useLocalizedStrings()
  const {
    aggregationOptions,
    getAggregationOption
  } = useAggregationOptions()
  const { fieldOptions, getSelectedFieldOption } = useFieldOptions()

  return <>
    <Input 
      required
      label={L.admin_panel.dashboards.chart_title}
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />
    
    <Input 
      required
      placeholder={L.admin_panel.dashboards.metric_label}
      label={L.admin_panel.dashboards.category_dimension_x_axis}
      value={xAxis.title}
      onChange={(e) => setXAxis({...xAxis, title: e.target.value})}
    />
    <Select
      portal
      hideLabel
      virtualized
      options={fieldOptions}
      label={L.admin_panel.dashboards.category_dimension_data_field}
      description="Select the field to group categories by"
      labelLocation="above"
      value={getSelectedFieldOption(xAxis.dataField)}
      onChange={(value) => {
        if (value) setXAxis({...xAxis, dataField: value.value})
      }}
      placeholder="Choose a field..."
      searchable
    />
    
    <Input
      required
      label={L.admin_panel.dashboards.measures_y_axis}
      placeholder={L.admin_panel.dashboards.metric_label}
      value={yAxis.title}
      onChange={(e) => setYAxis({...yAxis, title: e.target.value})}
    />
    <Select
      // TODO: add required
      portal
      virtualized
      options={aggregationOptions}
      label={L.admin_panel.dashboards.aggregation}
      description={L.admin_panel.dashboards.aggregation_desc}
      labelLocation="inline"
      value={getAggregationOption(yAxis.aggregation)}
      onChange={(value) => setYAxis({...yAxis, aggregation: value.value})}
    />
    {yAxis.aggregation !== 'Count' && (
      <Select
        hideLabel
        portal
        virtualized
        options={fieldOptions}
        label={L.admin_panel.dashboards.y_axis_data_field}
        description="Select the field to aggregate for Y-axis values"
        value={getSelectedFieldOption(yAxis.dataField)}
        onChange={(value) => {
          if (value) setYAxis({...yAxis, dataField: value.value})}
        }
        placeholder="Choose a field..."
        searchable
      />
    )}
        
    <TextArea
      label={L.admin_panel.dashboards.description}
      showLabel
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  </>
}